module.exports = __webpack_public_path__ + "img/AI口說.f07bab33.png";